<template>
    <div class="primary">
        <v-content>
            <v-navigation-drawer
                permanent
                width="100%">
                <v-row
                    class="fill-height"
                    no-gutters>
                    <sidebar />
                    <v-col>
                        <v-container class="main-content">
                            <user-profile />
                            <router-view></router-view>
                        </v-container>
                    </v-col>
                </v-row>

            </v-navigation-drawer>
        </v-content>
  </div>
</template>

<script>
import UserProfile from '@/components/UserProfile'
import Sidebar from '@/components/Sidebar.vue'

export default {
    components: {
        UserProfile,
        Sidebar
    }
}
</script>

<style lang="scss" scoped>
    .container {
        padding: 2rem 4rem;
    }
    .primary {
        height: 100%;
        .v-content {
            height: 100%;
        }
        .col {
            background-color: #f7f7f7;
        }
    }

    .main-content {
        overflow-y: scroll;
        height: 100vh;
    }
    .main-content::-webkit-scrollbar {
        width: 12px;
        background-color: #F5F5F5;
    }

    .main-content::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #555;
    }

    .main-content::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #F5F5F5;
    }
</style>
